import ViewSupplier from "../../../../components/@users/suppliers/ViewSupplier";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function SupplierViewPage() {

    return (
        <ViewSupplier 
            routeType={routeTypes.admin}
        />
    )
}       